// WholesaleOS landing page — standalone bundle.
//
// Renders the marketing hero + feature grid + footer. Zero dependencies —
// just reads window.WholesaleOSBoot and renders into #wholesaleos-root.

(function () {
  'use strict';

  var cfg = window.WholesaleOSBoot || {};
  var root = document.getElementById('wholesaleos-root');
  if (!root) { return; }

  var copy = cfg.copy || {};
  var features = Array.isArray(copy.features) ? copy.features : [];

  var html =
    '<section class="wos-hero">' +
      '<h1>' + escapeHtml(copy.headline || 'WholesaleOS') + '</h1>' +
      '<p class="wos-hero-sub">' + escapeHtml(copy.subheadline || '') + '</p>' +
      '<div class="wos-hero-actions">' +
        (cfg.isLoggedIn
          ? '<a class="wos-btn wos-btn-primary" href="' + escapeAttr(cfg.appUrl || '/app') + '">Open workspace</a>'
          : '<a class="wos-btn wos-btn-primary" href="' + escapeAttr(cfg.loginUrl || '/login') + '">' + escapeHtml(copy.cta || 'Sign in') + '</a>'
        ) +
      '</div>' +
    '</section>' +

    (features.length ? (
      '<section class="wos-features">' +
        '<div class="wos-features-grid">' +
          features.map(function (f) {
            return '<article class="wos-feature">' +
              '<h3>' + escapeHtml(f.title || '') + '</h3>' +
              '<p>' + escapeHtml(f.description || '') + '</p>' +
            '</article>';
          }).join('') +
        '</div>' +
      '</section>'
    ) : '') +

    (copy.disclaimer ? '<p class="wos-disclaimer">' + escapeHtml(copy.disclaimer) + '</p>' : '');

  root.innerHTML = html;

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;' })[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }
})();
